/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PulleyEditorForm from './PulleyEditorForm';

// 테스트용. 사용하고 지울 것.
// import { pulleys as testValue } from './pulleyDataSample';
import { useSelector } from 'react-redux';
import { getMinPulleyDia, /*getPulleyDimensions,*/ getPulleyWeight, getShaftDia } from '../../lib/data/pulley-data-new';
import { plummerBlocks } from '../../lib/data/plummerBlock-data';
import { changeBody, /*initialize, setOriginalConveyor*/ } from '../../modules/conveyor/conveyorWriteSlice';
import { useNavigate } from 'react-router-dom';

import ButtonBackToList from '../common/ButtonBackToList';
import AskDrivePulleySelectionModal from './AskDrivePulleySelectionModal';
import AskDrivePulleyEditModal from './AskDrivePulleyEditModal';

/** DTr 등등 모든 Pulley에 공통적인 값은 여기서 계산하거나 추출해서 넘긴다. */
const PulleyEditorFormContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const project = useSelector((state) => state.project.project);
    const title = useSelector((state) => state.conveyorWrite.title);
    const prevPulleys = useSelector((state) => state.conveyorWrite.body.pulleys);
    // console.log('prevPulleys : ', prevPulleys);
    // const prevPulleys = testValue;
    // const prevBeltWidth = useSelector(state => state.conveyorWrite.body.pulleys[0]?.beltWidth);
    const prevBeltWidth = (prevPulleys && prevPulleys.length >= 1 && prevPulleys[0].beltWidth) || null;
    const beltWidth = useSelector((state) => state.conveyorWrite.body.input.beltWidth);
    const beltSpeed = useSelector((state) => state.conveyorWrite.body.input.beltSpeed);
    const minPulleyDiaByBelt = useSelector((state) => state.conveyorWrite.body.belt?.minPulleyDia);
    const drivePulley = useSelector((state) => state.conveyorWrite.body.drivePulley);

    const [pulleys, setPulleys] = useState(
        prevPulleys && prevPulleys.length > 0
            ? prevPulleys
            : [
                  {
                      id: 1,
                      beltWidth,
                  },
              ],
    );

    const pulleyTypeCategory = useRef({
        '1st Drive': 'A',
        '2nd Drive': 'A',
        '1st Snub': 'C',
        '2nd Snub': 'C',
        'Bend': 'B',
        'Takeup': 'B',
        'Tail': 'B',
        'HTBend': 'A',
        'LTBend': 'B',
    });

    /* 여기부터 드라이브 풀리가 정해지지 않았을 채 처리하는 프로세스 */
    const [selectionModal, setSelectionModal] = useState(false);
    const [editModal, setEditModal] = useState(false);

    const onCancelSelection = () => {
        navigate(`/projects/${project?.id}/pulley`);
        setSelectionModal(false);
    };

    const onConfirmSelection = () => {
        // 컨베이어 편집창으로 이동
        // dispatch(setOriginalConveyor(conveyor));     // 이미 PulleyList에서 setOriginalConveyor()를 했으므로....
        navigate(`/write/conveyor`);
        setSelectionModal(false);
    };

    // useEffect(() => {
    //     if (!drivePulley || !drivePulley.diaSelected) {
    //         setSelectionModal(true);
    //     }
    // }, [drivePulley]);

    /* 여기까지가 드라이브 풀리가 정해지지 않았을 채 처리하는 프로세스 */

    /* 풀리를 저장하고 돌아온 리스트 화면에서 뒤로가기를 누르면 conveyorWrite에 아무런 정보가 없기 때문에 에러가 발생하게 된다. 
        리덕스에 conveyorWrite 정보가 없으면 즉, 제대로 된 루트로 이 화면에 들어온 것이 아니기 때문에 '리스트로 돌아가기' 버튼을 배치한다 */
    if (!title) {
        return (
            <ButtonBackToList cyan to={`/projects/${project?._id}/pulley`}>
                Back to List
            </ButtonBackToList>
        );
    }

    /* 시작. 드라이브 풀리 직경을 클릭하여 컨베이어 편집창으로 이동하는 기능 구현 */
    const onCancelEdit = () => {
        // navigate(`/projects/${project?.id}/pulley`);
        setEditModal(false);
    }

    const onConfirmEdit = (conveyor) => {
        // 컨베이어 편집창으로 이동
        // dispatch(setOriginalConveyor(conveyor));     // 이미 PulleyList에서 setOriginalConveyor()를 했으므로....
        navigate(`/write/conveyor`);
        setEditModal(false);
    };

    const handleEditDrivePulley = () => {
        // setEditModal(true);  // 컨베이어 수정창으로 갔다가 거기서 취소를 하면 navigate(-1)이 실행되는데 이 때 에러가 발생하고 있다. '24.7/4
    }

    if (prevBeltWidth !== beltWidth) {
        /* 구현 예정 */
        // alert('이전 풀리 계산에서 사용된 벨트폭과 현재의 벨트 폭이 달라졌습니다. 새로 풀리를 계산하시겠습니까? 기존 자료는 지워집니다.');
    }
    /* 끝. 드라이브 풀리 직경을 클릭하여 컨베이어 편집창으로 이동하는 기능 구현 */


    const handleChange = (e) => {
        const { name, value } = e.target;
        const [form, key] = name.split('_'); //  name="1_description",
        setPulleys((prev) =>
            prev.map((pulley) =>
                pulley.id === Number(form)
                    ? {
                          ...pulley,
                          [key]: value,
                      }
                    : pulley,
            ),
        );
    };

    /* Pulley Application을 선택하면 PulleyTypeCategory 정하기, minPulleyDia. 가져오기 */
    const handleApplicationSelect = (e) => {
        const { name, value } = e.target; // name: '1_application', value="Drive"
        const [form, key] = name.split('_'); // form: '1', key: 'application'
        const _category = pulleyTypeCategory.current[value];
        // const _minPulleyDia = minPulleyDia[_category];

        setPulleys((prev) =>
            prev.map((pulley) =>
                pulley.id === Number(form)
                    ? {
                          ...pulley,
                          [key]: value,
                          pulleyTypeCategory: _category,
                        //   minPulleyDia: _minPulleyDia,
                      }
                    : pulley,
            ),
        );

        if (value === 'Drive') {
            const diaSelected = drivePulley.diaSelected;
            const laggingThick = drivePulley.laggingThick;
            const diaWithLagging = drivePulley.diaWithLagging;
            const RPM = drivePulley.RPM;

            setPulleys((prev) =>
                prev.map((pulley) =>
                    pulley.id === Number(form)
                        ? {
                              ...pulley,
                              [key]: value,
                              diaSelected,
                              laggingThick,
                              diaWithLagging,
                              RPM,
                          }
                        : pulley,
                ),
            );
        }
    };

    /* Drive Pulley Dia.가 ConveyorEditor에서 수정되면 해당 내용이 반영되게 해야 함. */
    useEffect(() => {
        if (!drivePulley) return;
        setPulleys(prev => prev.map(pulley => 
            pulley.application === 'Drive' ? {
                ...pulley,
                diaSelected: drivePulley.diaSelected,
                laggingThick: drivePulley.laggingThick,
                diaWithLagging: drivePulley.diaWithLagging,
                RPM: drivePulley.RPM,

            } : pulley,
        ));
    }, []); // 처음 로딩될 때만

    /* Pulley Dia. Selection */
    const handleDiaSelection = (e) => {
        const { name, value } = e.target;
        const [form, key] = name.split('_');

        setPulleys((prev) =>
            prev.map((pulley) =>
                pulley.id === Number(form)
                    ? {
                          ...pulley,
                          [key]: value,
                      }
                    : pulley,
            ),
        );
    };

    /* 기존에 pulley가 있는데 닫았다가 다시 열면 다시 nextId가 1이 되기 때문에 이전 id와 중복됨. 이를 해결하기 위한 코드 추가. '24.2/28 */
    const getLastId = () => {
        if (!pulleys) {
            return;
        }
        if (!pulleys?.length) {
            return 0;
        }
        if (!pulleys?.length === 1) {
            return 1;
        }
        const lastId = pulleys.reduce((accumulator, currentValue) => {
            if (currentValue.id > accumulator.id) {
                return currentValue;
            }
            return accumulator;
        });
        // console.log(lastId.id);
        return lastId.id;
    };

    /* 풀리 추가 버튼을 눌렀을 때 풀리를 추가한다. */
    const nextId = useRef(getLastId() + 1);
    const onAddPulley = () => {
        setPulleys((prev) => [
            ...prev,
            {
                id: nextId.current++,
                beltWidth,
            },
        ]);
        // nextId.current++;
    };

    /* 풀리 삭제 버튼을 눌렀을 때 풀리를 삭제한다. */
    const onRemovePulley = (id) => {
        setPulleys((prev) => prev.filter((pulley) => pulley.id !== id));
    };

    /* 벨트폭과 풀리 타입(드라이브, 논드라이브)이 변경되면 관련 치수를 가지고 온다. */
    // useEffect(() => {
    //     const updatedPulleys = pulleys.map(pulley => {
    //         // 여기부터 필요한 계산을 넣는다.
    //         // const beltWidth = 1400;
    //         const isDrive = pulley.application === 'Drive' ? true : false;
    //         // console.log('beltWidth : ', beltWidth);
    //         const [brgDistance, webDistance, momentArm] = getPulleyDimensions(beltWidth, isDrive);

    //         // 여기까지 필요한 계산을 넣는다.
    //         return { ...pulley, brgDistance, webDistance, momentArm };
    //     });
    //     setPulleys(updatedPulleys);
    // }, [pulleys.map(pulley => `${pulley.application}-${beltWidth}`).join(",")]);


    /* Resultant Force, Torque 계산 */
    useEffect(() => {
        // 구현 예정 ('24.7/3)
    }, []);


    /* Shaft Dia. 계산 */
    useEffect(() => {
        const updatedPulleys = pulleys.map((pulley) => {
            // 여기부터 필요한 계산을 넣는다.
            const isDrive = pulley.application === 'Drive' ? true : false;
            // const [maxMoment, hubDiaByStress, hubDiaByDeflection, hubDiaCalculated] = getShaftDia(pulley.resultantForce, pulley.torque, pulley.eccentricFactor, beltWidth, isDrive);
            // hub dia.를 다시 선택하게 하지 말고 계산된 값을 그대로 사용하는 것으로 하자. 바꾸고 싶으면 아래 라인을 주석처리하고 윗 라인을 살리면 된다.
            const [
                brgDistance,
                webDistance,
                momentArm,
                maxMoment,
                hubDiaByStress,
                hubDiaByDeflection,
                hubDiaCalculated,
            ] = getShaftDia(pulley.resultantForce, pulley.torque, pulley.eccentricFactor, beltWidth, isDrive);

            // let brgDiaCalculated;
            // if (pulley.hubDiaSelected) {
            //     const [, , , , , , brgDiaCalculated1] = getShaftDia(
            //         pulley.resultantForce * 0.4,
            //         pulley.torque,
            //         pulley.eccentricFactor,
            //         beltWidth,
            //         isDrive,
            //     );
            //     // const brgDiaCalculated2 = (0.9) * pulley.hubDiaSelected;   // 단차가 10%이상 있으면 안된다. by Mulani
            //     const brgDiaCalculated2 = 0;
            //     brgDiaCalculated = Math.round(Math.max(brgDiaCalculated1, brgDiaCalculated2) * 10) / 10;
            // } else {
            //     brgDiaCalculated = '';
            // }

            const [, , , , , , brgDiaCalculated] = getShaftDia(pulley.resultantForce * 0.4, pulley.torque, pulley.eccentricFactor, beltWidth, isDrive);

            // 여기까지 필요한 계산을 넣는다.
            return {
                ...pulley,
                brgDistance,
                webDistance,
                momentArm,
                maxMoment,
                hubDiaByStress,
                hubDiaByDeflection,
                hubDiaSelected: hubDiaCalculated,
                brgDiaCalculated,
            };
        });
        setPulleys(updatedPulleys);
    }, [
        pulleys
            .map(
                (pulley) =>
                    `${pulley.resultantForce}-${pulley.torque}-${pulley.eccentricFactor}-${beltWidth}`,
            )
            .join(','),
    ]);

    /* Minimum Pulley Dia. 산정 */
    // useEffect(() => {
    //     const updatedPulleys = pulleys.map(pulley => {
    //         // 여기부터 필요한 계산을 넣는다.
    //         if (!pulley.hubDiaSelected) return pulley;

    //         const minDiaByBelt = minPulleyDiaByBelt[pulley.pulleyTypeCategory];
    //         const [minDiaByHubDia, minDiaByShapeRatio] = getMinPulleyDia(pulley.beltWidth, pulley.hubDiaSelected, pulley.pulleyTypeCategory);
    //         console.log('minDiaByHubDia, minDiaByShapeRatio : ', minDiaByHubDia, minDiaByShapeRatio);
    //         const minPulleyDia = Math.max(minDiaByBelt, minDiaByHubDia, minDiaByShapeRatio);
    //         return {
    //             ...pulley,
    //             minPulleyDia,
    //             minDiaByBelt,
    //             minDiaByHubDia,
    //             minDiaByShapeRatio,
    //         };

    //     });
    //     setPulleys(updatedPulleys);
    // }, [pulleys.map(pulley => `${pulley.pulleyTypeCategory}-${pulley.beltWidth}-${pulley.hubDiaSelected}`).join(',')]);

    /* Pulley Dia with Lagging, RPM 계산 */
    // useEffect(() => {
    //     const updatedPulleys = pulleys.map((pulley) => {
    //         // 여기부터 필요한 계산을 넣는다.
    //         const diaWithLagging = Number(pulley.diaSelected) + Number(pulley.laggingThick) * 2;
    //         const rpm = (Number(beltSpeed) * 60) / ((Math.PI * diaWithLagging) / 1000);

    //         console.log('Pulley Dia with Lagging, RPM 계산 훅');

    //         return {
    //             ...pulley,
    //             diaWithLagging,
    //             RPM: Math.round(rpm * 10) / 10,
    //         };
    //     });
    //     setPulleys(updatedPulleys);
    // }, [pulleys.map((pulley) => `${pulley.diaSelected}-${pulley.laggingThick}-${beltSpeed}`).join(',')]);

    /* Bearing, PlummerBlock 선정 */
    useEffect(() => {
        const updatedPulleys = pulleys.map((pulley) => {
            // 여기부터 필요한 계산을 넣는다.
            if (!pulley.brgDiaSelected) return pulley;

            const obj = plummerBlocks.find(({ dia }) => dia >= Number(pulley.brgDiaSelected)); // *10은 단위 환산(cm -> mm)

            return {
                ...pulley,
                // brgDiaSelected: obj.dia,
                plummerBlockNumber: obj.model,
                plummerBlockWeight: obj.weight,
                brgNumber: obj.bearing,
                dynamicRating: obj.dynamicRating,
            };
        });
        setPulleys(updatedPulleys);
    }, [pulleys.map((pulley) => `${pulley.brgDiaSelected}-${pulley.RPM}`).join(',')]);

    /* Min. Pulley Dia, Pulley Estimated Weight */
    useEffect(() => {
        const updatedPulleys = pulleys.map(pulley => {
            // 여기부터 필요한 계산을 넣는다
            if (!minPulleyDiaByBelt) return pulley;
            // Minimum Pulley Dia. 산정 //
            const minDiaByBelt = minPulleyDiaByBelt[pulley.pulleyTypeCategory];
            const [minDiaByHubDia, minDiaByShapeRatio] = getMinPulleyDia(pulley.beltWidth, pulley.hubDiaSelected, pulley.pulleyTypeCategory);
            const minPulleyDia = Math.max(minDiaByBelt, minDiaByHubDia, minDiaByShapeRatio);

            // Pulley Dia with Lagging, RPM 계산
            const diaWithLagging = Number(pulley.diaSelected) + Number(pulley.laggingThick) * 2;
            const rpm = (Number(beltSpeed) * 60) / ((Math.PI * diaWithLagging) / 1000);

            // 여기부터 중량 계산
            const isDrive = pulley.application === 'Drive' ? true : false;
            const { beltWidth, hubDiaSelected, brgDistance, webDistance, diaSelected, laggingThick } = pulley;

            const weight = getPulleyWeight(isDrive, beltWidth, hubDiaSelected, brgDistance, webDistance, diaSelected, laggingThick);

            return {
                ...pulley,
                minPulleyDia,
                minDiaByBelt,
                minDiaByHubDia,
                minDiaByShapeRatio,
                diaWithLagging,
                RPM: Math.round(rpm * 10) / 10,
                weight,
            };
        });
        setPulleys(updatedPulleys);
    }, [pulleys.map(pulley => `${pulley.pulleyTypeCategory}-${pulley.beltWidth}-${pulley.hubDiaSelected}-${pulley.brgDistance}-${pulley.webDistance}-${pulley.diaSelected}-${pulley.laggingThick}`).join(','), beltSpeed]);

    /* 언마운트시 리덕스 스토어 writeConveyor 초기화 */
    useEffect(() => {

        // return () => {
        //     dispatch(initialize());
        // };
    }, [dispatch]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        if (!pulleys) return;

        /* pulleys를 indexArry에 따라 정렬하자. 입려할 때 순서가 바뀔수도 있다. */
        const indexArray = ['1st Drive', '2nd Drive', '1st Snub', '2nd Snub', 'Bend', 'Takeup', 'Tail', 'HTBend', 'LTBend'];
        const sortedPulleys = [...pulleys].sort((a, b) => {
            const indexA = indexArray.indexOf(a.application);
            const indexB = indexArray.indexOf(b.application);
            // 만약 indexArray에 없는 application이 있다면, 정렬 순서에서 마지막으로 배치
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });

        dispatch(
            changeBody({
                key: 'pulleys',
                value: sortedPulleys,
            }),
        );
    }, [dispatch, pulleys]);

    return (
        <>
            {editModal && <AskDrivePulleyEditModal visible={editModal} onConfirm={onConfirmEdit} onCancel={onCancelEdit} />}
            {selectionModal && <AskDrivePulleySelectionModal visible={selectionModal} onConfirm={onConfirmSelection} onCancel={onCancelSelection} />}
            <PulleyEditorForm
                pulleys={pulleys}
                // minPulleyDia={minPulleyDia}
                drivePulley={drivePulley}
                handleChange={handleChange}
                handleApplicationSelect={handleApplicationSelect}
                handleDiaSelection={handleDiaSelection}
                handleEditDrivePulley={handleEditDrivePulley}
                setPulleys={setPulleys}
                onAddPulley={onAddPulley}
                onRemovePulley={onRemovePulley}
            />
        </>
    );
};

export default PulleyEditorFormContainer;
